import { Box, Grid, Typography } from "@material-ui/core";
import ProgrammeCategory from "./programmeCategoryForm";

export default function ProgrammeCategoryEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Film &gt; Edit Programme Category
        </Typography>
      </Box>
      <Grid container xs={6}>
        <ProgrammeCategory
          description="Edit Category"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
